import { type FC } from 'react';

import { type LotterySeasonHistoryData } from '@/common/types/lottery';

import { LotterySeasonHistoryItem } from './LotterySeasonHistoryItem/LotterySeasonHistoryItem';

interface LotterySeasonHistoryListProps {
  data: LotterySeasonHistoryData[];
  activeId: string;
  changeSeason: (seasonId: string) => void;
}

const LotterySeasonHistoryList: FC<LotterySeasonHistoryListProps> = ({
  data,
  activeId,
  changeSeason,
}) => {
  return (
    <div className="w-full flex flex-col gap-[2px] flex-1 overflow-y-auto hidden-scrollbar">
      {data.map((props) => (
        <LotterySeasonHistoryItem
          handleClick={() => changeSeason(props.id)}
          isActive={activeId === props.id}
          key={props.id}
          {...props}
        />
      ))}
    </div>
  );
};

export { LotterySeasonHistoryList };
